enum Destination {
  InRussia,
  ToOtherCountries,
}

const { InRussia, ToOtherCountries } = Destination

const nameMapping = new Map([
  [InRussia, 'По\xA0России'],
  [ToOtherCountries, 'В\xA0другую страну']
])

namespace Destination {
  export const sortedMembers = [InRussia, ToOtherCountries]

  export function getName (destinationCountry: Destination): string {
    return nameMapping.get(destinationCountry)!
  }
}

export default Destination
